import React from 'react';
import PropTypes from 'prop-types';
import Downshift from 'downshift';
import { debounce } from 'lodash';
import { MenuItem, Paper } from '@material-ui/core';
import { TextFieldWrapper } from './form';

const ITEMS_PER_PAGE = 10;
const itemToString = item => (item ? item.label : '');

function renderInput({ InputProps, ref, ...rest }) {
  return (
    <TextFieldWrapper
      {...rest}
      InputProps={{
        ...InputProps,
        inputRef: ref,
      }}
    />
  );
}

renderInput.propTypes = {
  ref: PropTypes.node.isRequired,

  InputProps: PropTypes.object,
};

function renderSuggestion({ suggestion, index, ItemProps, highlightedIndex }) {
  const isHighlighted = highlightedIndex === index;

  return (
    <MenuItem {...ItemProps} component="div" selected={isHighlighted}>
      {suggestion.label}
    </MenuItem>
  );
}

renderSuggestion.propTypes = {
  ItemProps: PropTypes.object.isRequired,
  suggestion: PropTypes.shape({ label: PropTypes.string.isRequired })
    .isRequired,

  highlightedIndex: PropTypes.number,
  index: PropTypes.number,
};

class AutoComplete extends React.Component {
  state = {
    hasMoreItems: false,
    inputValue: undefined,
    page: 1,
    suggestions: [],
  };

  onChange = selection => {
    const { field, form } = this.props;

    form.setFieldValue(field.name, selection);
  };

  handleInputValueChange = debounce(inputValue => {
    const { getSuggestions } = this.props;

    getSuggestions(inputValue).then(suggestions => {
      this.setState({
        hasMoreItems: suggestions && suggestions.length === ITEMS_PER_PAGE,
        inputValue,
        page: 1,
        suggestions,
      });
    });
  }, 300);

  handleGetMoreResults = () => {
    const { getSuggestions } = this.props;
    const { inputValue, page, suggestions } = this.state;
    const nextPage = page + 1;
    getSuggestions(inputValue, nextPage).then(nextSuggestions => {
      this.setState({
        suggestions: suggestions.concat(nextSuggestions),
        page: nextPage,
      });
    });
  };

  render() {
    const {
      defaultSelectedItem,
      field,
      form,
      fullWidth,
      id,
      label,
      paths,
      required,
    } = this.props;
    const { hasMoreItems, suggestions } = this.state;
    return (
      <Downshift
        defaultSelectedItem={defaultSelectedItem}
        itemToString={itemToString}
        onChange={this.onChange}
        onInputValueChange={this.handleInputValueChange}
      >
        {({
          getInputProps,
          getItemProps,
          isOpen,
          inputValue,
          highlightedIndex,
        }) => (
          <div>
            {renderInput({
              InputProps: getInputProps({
                id,
              }),
              field: {
                ...field,
                value: itemToString(field.value),
              },
              form,
              fullWidth,
              label,
              paths,
              required,
            })}
            {isOpen && (
              <Paper square>
                {suggestions.map((suggestion, index) =>
                  renderSuggestion({
                    suggestion,
                    index,
                    ItemProps: getItemProps({
                      item: suggestion,
                      key: suggestion.id,
                    }),
                    highlightedIndex,
                  }),
                )}
                {hasMoreItems && (
                  <MenuItem
                    component="div"
                    key="getMoreResults"
                    onClick={this.handleGetMoreResults}
                  >
                    Load more items...
                  </MenuItem>
                )}
              </Paper>
            )}
          </div>
        )}
      </Downshift>
    );
  }
}

AutoComplete.propTypes = {
  field: PropTypes.shape({ name: PropTypes.string.isRequired }).isRequired,
  form: PropTypes.shape({
    setFieldValue: PropTypes.func.isRequired,
    values: PropTypes.object.isRequired,
  }).isRequired,
  getSuggestions: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  paths: PropTypes.array.isRequired,

  defaultSelectedItem: PropTypes.object,
  fullWidth: PropTypes.bool,
  label: PropTypes.string,
  margin: PropTypes.string,
  required: PropTypes.bool,
};

AutoComplete.defaultProps = {
  fullWidth: true,
  margin: 'normal',
  paths: [],
  required: false,
};

export default AutoComplete;



// WEBPACK FOOTER //
// ./src/modules/common/AutoComplete.js